export default class {
  critere1 = null
  critere2 = null
  critere3 = null
  critere4 = null
  critere5 = null
  critere6 = null
  categorieDAssuranceCalculee = null
  categorieDAssuranceSelectionnee = null
  montantGarantie = null
  declarationCategorieB = null
}